import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Tabs from '@/components/molecules/Tabs';
import { useCageScopedSearch } from '@/contexts/cage-filter-context';

function resolveHealthRootUrl(pathname: string): string {
    const healthIndex = pathname.indexOf('/health');
    if (healthIndex >= 0) {
        return pathname.slice(0, healthIndex + '/health'.length);
    }

    return pathname.replace(/\/(body-wounds(\/.*)?|snout-wounds)$/, '');
}

export default function HealthWoundsPrimaryTabBar() {
    const { t } = useTranslation('healthModule');
    const location = useLocation();
    const search = useCageScopedSearch();

    const healthRootUrl = useMemo(
        () => resolveHealthRootUrl(location.pathname),
        [location.pathname]
    );

    const bodyBaseUrl = `${healthRootUrl}/body-wounds`;
    const snoutPath = `${healthRootUrl}/snout-wounds`;

    const isBodySection = location.pathname.includes('/body-wounds');
    const isSnoutSection = location.pathname.includes('/snout-wounds');

    return (
        <Tabs
            value={isBodySection ? 'body' : isSnoutSection ? 'snout' : undefined}
            items={[
                {
                    value: 'body',
                    label: t('routes.bodyWounds'),
                    to: `${bodyBaseUrl}/laksvel${search}`,
                },
                { value: 'snout', label: t('routes.snoutWounds'), to: `${snoutPath}${search}` },
            ]}
        />
    );
}
